import { crearReducerDeFormulas } from './crearReducerDeFormulas'
import { TIPOS_COSTO } from '../../actions/ConfigCostActions'

/**
 * Estado del listado de **costos** (H7).
 *
 * Comparte implementación con el de precios a través de la fábrica, pero vive
 * en su propio trozo del store: `state.configuration.cost`. Es lo que impide
 * que una pantalla pise los filtros o los datos de la otra.
 */
export default crearReducerDeFormulas({
  tipos: TIPOS_COSTO,
  rutaBase: '/configuration/costs'
})
